import isAuth from "@/middleware/isAuth";
import isAuthorized from "@/middleware/isAuthorized";
import isAdmin from "@/middleware/isAdmin";
export default [
  //Admin Routes
  {
    path: "/years",
    name: "years",
    component: () =>
      import(/* webpackChunkName: "Years" */ "@/views/admin/years/"),
    meta: {
      layout: "default",
      title: "manage_years",
      description: "manage_organize_years",
      permission: "dashboard.year.list",
      middleware: [isAuth, isAuthorized],
    },
  },

  {
    path: "/year/:yearId",
    name: "years_id",
    component: () =>
      import(
        /* webpackChunkName: "Show Year" */ "@/views/admin/years/show.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_years",
      description: "manage_organize_years",
      permission: "dashboard.year.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/grades",
    name: "years_id_grades",
    component: () =>
      import(
        /* webpackChunkName: "Show Year Grades" */ "@/views/admin/years/grades/"
      ),
    meta: {
      layout: "default",
      title: "manage_years",
      description: "manage_organize_years",
      permission: "dashboard.grade.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/grades/:gradeId",
    name: "year_grade_id_edu_classes",
    component: () =>
      import(
        /* webpackChunkName: "Year Grade Edu Classes" */ "@/views/admin/years/grades/show.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_edu_classes",
      description: "manage_organize_edu_classes",
      permission: "dashboard.eduClass.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/grades/:gradeId/edu-classes/:eduClassId",
    name: "year_grade_id_edu_classes_id",
    component: () =>
      import(
        /* webpackChunkName: "Year Grade Edu Classes" */ "@/views/admin/years/grades/eduClasses/show.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_edu_classes",
      description: "manage_organize_edu_classes",
      permission: "dashboard.eduClass.show",
      middleware: [isAuth, isAuthorized],
    },
  },

  {
    path: "/year/:yearId/grades/:gradeId/edu-classes/:eduClassId/exams/:examId",
    name: "year_grade_id_edu_classes_id_exam_id",
    component: () =>
      import(
        /* webpackChunkName: "Year Grade Edu Classes Exams" */ "@/views/admin/years/grades/eduClasses/exams/show"
      ),
    meta: {
      layout: "default",
      title: "manage_exams",
      description: "manage_organize_exams",
      permission: "dashboard.exam.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/grades/:gradeId/edu-classes/:eduClassId/quizzes/add",
    name: "year_grade_id_edu_classes_id_quizzes_add",
    component: () =>
      import(
        /* webpackChunkName: "Year Grade Edu Classes" */ "@/views/admin/years/grades/eduClasses/quizzes/create.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_quizzes",
      description: "manage_organize_quizzes",
      permission: "dashboard.quiz.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/grades/:gradeId/edu-classes/:eduClassId/quizzes/edit/:quizId",
    name: "year_grade_id_edu_classes_id_quizzes_edit",
    component: () =>
      import(
        /* webpackChunkName: "Year Grade Edu Classes" */ "@/views/admin/years/grades/eduClasses/quizzes/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_quizzes",
      description: "manage_organize_quizzes",
      permission: "dashboard.quiz.update",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/grades/:gradeId/edu-classes/:eduClassId/quizzes/:quizId/solve",
    name: "year_grade_id_edu_classes_id_quizzes_solve",
    component: () =>
      import(
        /* webpackChunkName: "Quiz Solve" */ "@/views/admin/years/grades/eduClasses/quizzes/solve.vue"
      ),
    meta: {
      layout: "default",
      title: "solve_exam",
      description: "solve_exam",
      permission: "dashboard.quiz.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/quizzes/:quizId/solutions",
    name: "quizzes_solutions",
    component: () =>
      import(
        /* webpackChunkName: "Year Grade Edu Classes" */ "@/views/admin/years/grades/eduClasses/quizzes/solutions.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_quizzes",
      description: "manage_organize_quizzes",
      permission: "dashboard.quiz.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/quizzes/:quizId/teacher-solutions",
    name: "quizzes_teacher_solutions",
    component: () =>
      import(
        /* webpackChunkName: "Quiz Teacher Solutions" */ "@/views/admin/years/grades/eduClasses/quizzes/teacherSolutions.vue"
      ),
    meta: {
      layout: "default",
      title: "teacher_solutions",
      description: "teacher_solutions",
      role: "ADMIN",
      middleware: [isAuth, isAdmin],
    },
  },

  {
    path: "/year/:yearId/employees",
    name: "yearEmployees",
    component: () =>
      import(
        /* webpackChunkName: "Year Employees" */ "@/views/admin/years/yearEmployees/index.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_year_employees",
      description: "manage_organize_manage_year_employees",
      permission: "dashboard.yearEmployee.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/holidays",
    name: "holidays",
    component: () =>
      import(
        /* webpackChunkName: "Holidays" */ "@/views/admin/years/holidays/"
      ),
    meta: {
      layout: "default",
      title: "manage_holidays",
      description: "manage_organize_holidays",
      permission: "dashboard.holiday.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/teachers",
    name: "teachers",
    component: () =>
      import(/* webpackChunkName: "Teachers" */ "@/views/admin/teachers/"),
    meta: {
      layout: "default",
      title: "manage_teachers",
      description: "manage_organize_teachers",
      permission: "dashboard.teacher.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/teacher/create",
    name: "teacher_create",
    component: () =>
      import(
        /* webpackChunkName: "teacherCreate" */ "@/views/admin/teachers/create.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_teachers",
      description: "manage_organize_teachers",
      permission: "dashboard.teacher.create",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/teacher/edit/:id",
    name: "teacher_edit",
    component: () =>
      import(
        /* webpackChunkName: "teacherEdit" */ "@/views/admin/teachers/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_teachers",
      description: "manage_organize_teachers",
      permission: "dashboard.teacher.update",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/roles",
    name: "roles",
    component: () =>
      import(/* webpackChunkName: "Roles" */ "@/views/admin/roles/"),
    meta: {
      layout: "default",
      title: "manage_roles",
      description: "manage_organize_roles",
      permission: "dashboard.role.list",
      middleware: [isAuth, isAuthorized],
    },
  },

  {
    path: "/grades",
    name: "grades",
    component: () =>
      import(/* webpackChunkName: "Grades" */ "@/views/admin/grades/"),
    meta: {
      layout: "default",
      title: "manage_grades",
      description: "manage_organize_grades",
      permission: "dashboard.grade.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId",
    name: "grade_id",
    component: () =>
      import(
        /* webpackChunkName: "Grade Show" */ "@/views/admin/grades/show.vue"
      ),
    meta: {
      layout: "default",
      title: "subjects_in_this_grade",
      description: "manage_subjects_in_this_grade",
      permission: "dashboard.grade.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId",
    name: "subject_id",
    component: () =>
      import(
        /* webpackChunkName: "SUbject Show" */ "@/views/admin/grades/subjects/show.vue"
      ),
    meta: {
      layout: "default",
      title: "curriculum_in_this_subject",
      description: "manage_curriculum_in_this_subject",
      permission: "dashboard.grade.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan",
    name: "curriculum_study_plan",
    component: () =>
      import(
        /* webpackChunkName: "Study Plan" */ "@/views/admin/grades/subjects/curricula/study-plan/index.vue"
      ),
    meta: {
      layout: "default",
      title: "study_plan",
      description: "study_plan_subtitle",
      permission: "dashboard.studyPlan.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId",
    name: "admin_study_plan_teacher_show",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan" */ "@/views/teacher/study-plan/show.vue"
      ),
    meta: {
      layout: "default",
      title: "teacher_study_plan_workspace",
      description: "teacher_study_plan_workspace_subtitle",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/lessons/:itemId",
    name: "admin_study_plan_teacher_lesson",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Lesson" */ "@/views/teacher/study-plan/lesson.vue"
      ),
    meta: {
      layout: "default",
      title: "study_plan",
      description: "manage_lesson_materials",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/lessons/:itemId/questions/create",
    name: "admin_study_plan_teacher_lesson_questions_create",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Question Create" */ "@/views/teacher/grades/subjects/curricula/units/lessons/questions/create.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_questions",
      description: "manage_organize_questions",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/lessons/:itemId/questions/edit/:questionId",
    name: "admin_study_plan_teacher_lesson_questions_edit",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Question Edit" */ "@/views/teacher/grades/subjects/curricula/units/lessons/questions/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_questions",
      description: "manage_organize_questions",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/lessons/:itemId/quizzes/create",
    name: "admin_study_plan_teacher_lesson_quizzes_create",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Lesson Quiz Create" */ "@/views/admin/years/grades/eduClasses/quizzes/create.vue"
      ),
    meta: {
      layout: "default",
      title: "add_class_quiz",
      description: "manage_class_quizzes",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/lessons/:itemId/quizzes/:quizId/edit",
    name: "admin_study_plan_teacher_lesson_quizzes_edit",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Lesson Quiz Edit" */ "@/views/teacher/grades/eduClasses/quizzes/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "edit_class_quiz",
      description: "manage_class_quizzes",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/lessons/:itemId/quizzes/:quizId/solve",
    name: "admin_study_plan_teacher_lesson_quizzes_solve",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Lesson Quiz Solve" */ "@/views/teacher/grades/eduClasses/quizzes/solve.vue"
      ),
    meta: {
      layout: "default",
      title: "solve_exam",
      description: "solve_exam",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/units/:itemId",
    name: "admin_study_plan_teacher_unit",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Unit" */ "@/views/teacher/study-plan/assessment.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_unit_quizzes",
      description: "manage_unit_quizzes_hint",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/units/:itemId/quizzes/create",
    name: "admin_study_plan_teacher_unit_quizzes_create",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Unit Quiz Create" */ "@/views/admin/years/grades/eduClasses/quizzes/create.vue"
      ),
    meta: {
      layout: "default",
      title: "add_unit_quiz",
      description: "manage_unit_quizzes",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/units/:itemId/quizzes/:quizId/edit",
    name: "admin_study_plan_teacher_unit_quizzes_edit",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Unit Quiz Edit" */ "@/views/teacher/grades/eduClasses/quizzes/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "edit_unit_quiz",
      description: "manage_unit_quizzes",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/units/:itemId/quizzes/:quizId/solve",
    name: "admin_study_plan_teacher_unit_quizzes_solve",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Unit Quiz Solve" */ "@/views/teacher/grades/eduClasses/quizzes/solve.vue"
      ),
    meta: {
      layout: "default",
      title: "solve_exam",
      description: "solve_exam",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/:itemKind(quizzes|exams)/:itemId",
    name: "admin_study_plan_teacher_assessment",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Assessment" */ "@/views/teacher/study-plan/assessment.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_assessment_quizzes",
      description: "manage_assessment_quizzes_hint",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/:itemKind(quizzes|exams)/:itemId/class-quizzes/create",
    name: "admin_study_plan_teacher_assessment_quizzes_create",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Assessment Quiz Create" */ "@/views/admin/years/grades/eduClasses/quizzes/create.vue"
      ),
    meta: {
      layout: "default",
      title: "add_class_quiz",
      description: "manage_assessment_quizzes",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/:itemKind(quizzes|exams)/:itemId/class-quizzes/:quizId/edit",
    name: "admin_study_plan_teacher_assessment_quizzes_edit",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Assessment Quiz Edit" */ "@/views/teacher/grades/eduClasses/quizzes/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "edit_class_quiz",
      description: "manage_assessment_quizzes",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/:itemKind(quizzes|exams)/:itemId/class-quizzes/:quizId/solve",
    name: "admin_study_plan_teacher_assessment_quizzes_solve",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Assessment Quiz Solve" */ "@/views/teacher/grades/eduClasses/quizzes/solve.vue"
      ),
    meta: {
      layout: "default",
      title: "solve_exam",
      description: "solve_exam",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/study-plan/teachers/:teacherId/quizzes/:quizId/solutions",
    name: "admin_study_plan_teacher_quiz_solutions",
    component: () =>
      import(
        /* webpackChunkName: "Admin Teacher Study Plan Quiz Solutions" */ "@/views/teacher/grades/eduClasses/quizzes/solutions.vue"
      ),
    meta: {
      layout: "default",
      title: "view_solutions",
      description: "view_solutions",
      studyPlanWorkspace: "admin",
      permission: "dashboard.studyPlan.teacherWorkspace.listQuizSolutions",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId",
    name: "curriculum_show",
    component: () =>
      import(
        /* webpackChunkName: "Curriculum Show" */ "@/views/admin/grades/subjects/curricula/units/index.vue"
      ),
    meta: {
      layout: "default",
      title: "units_in_this_curriculum",
      description: "manage_units_in_this_curriculum",
      permission: "dashboard.grade.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/unit/:unitId",
    name: "unit_show",
    component: () =>
      import(
        /* webpackChunkName: "Unit Show" */ "@/views/admin/grades/subjects/curricula/units/lessons/index.vue"
      ),
    meta: {
      layout: "default",
      title: "lessons_in_this_unit",
      description: "manage_lessons_in_this_unit",
      permission: "dashboard.grade.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/unit/:unitId/lesson/:lessonId/questions",
    name: "lesson_questions_show",
    component: () =>
      import(
        /* webpackChunkName: "Lesson Questions Show" */ "@/views/admin/grades/subjects/curricula/units/lessons/questions/"
      ),
    meta: {
      layout: "default",
      title: "questions_in_this_lesson",
      description: "manage_questions_in_this_lesson",
      permission: "dashboard.grade.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/unit/:unitId/lesson/:lessonId/questions/create",
    name: "lesson_questions_create",
    component: () =>
      import(
        /* webpackChunkName: "Lesson Questions Create" */ "@/views/admin/grades/subjects/curricula/units/lessons/questions/create.vue"
      ),
    meta: {
      layout: "default",
      permission: "dashboard.grade.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/unit/:unitId/lesson/:lessonId/questions/edit/:questionId",
    name: "lesson_questions_edit",
    component: () =>
      import(
        /* webpackChunkName: "Lesson Questions Edit" */ "@/views/admin/grades/subjects/curricula/units/lessons/questions/edit.vue"
      ),
    meta: {
      layout: "default",
      permission: "dashboard.grade.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/grade/:gradeId/subject/:subjectId/curriculum/:curriculumId/unit/:unitId/lesson/:lessonId/academic-content",
    name: "lesson_academic_content_show",
    component: () =>
      import(
        /* webpackChunkName: "Lesson Academic Content Show" */ "@/views/admin/grades/subjects/curricula/units/lessons/academicContent/"
      ),
    meta: {
      layout: "default",
      title: "academic_content_in_this_lesson",
      description: "manage_academic_content_in_this_lesson",
      permission: "dashboard.grade.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/students",
    name: "students",
    component: () =>
      import(/* webpackChunkName: "Students" */ "@/views/admin/students/"),
    meta: {
      layout: "default",
      title: "manage_students",
      description: "manage_organize_students",
      permission: "dashboard.student.list",
      middleware: [isAuth, isAuthorized],
    },
  },

  {
    path: "/student/create",
    name: "student_create",
    component: () =>
      import(
        /* webpackChunkName: "Student Create" */ "@/views/admin/students/create.vue"
      ),
    meta: {
      layout: "default",
      permission: "dashboard.student.create",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/student/edit/:id",
    name: "student_edit",
    component: () =>
      import(
        /* webpackChunkName: "Student Edit" */ "@/views/admin/students/edit.vue"
      ),
    meta: {
      layout: "default",
      permission: "dashboard.student.update",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/student/:id",
    name: "student_show",
    component: () =>
      import(
        /* webpackChunkName: "Student Show" */ "@/views/admin/students/show.vue"
      ),
    meta: {
      layout: "default",
      // title: "manage_students",
      // description: "manage_organize_students",
      permission: "dashboard.student.show",
      middleware: [isAuth, isAuthorized],
    },
  },

  {
    path: "/departments",
    name: "departments",
    component: () =>
      import(
        /* webpackChunkName: "Departments" */ "@/views/admin/departments/"
      ),
    meta: {
      layout: "default",
      title: "manage_departments",
      description: "manage_organize_departments",
      permission: "dashboard.department.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/buses",
    name: "buses",
    component: () =>
      import(/* webpackChunkName: "Buses" */ "@/views/admin/buses/"),
    meta: {
      layout: "default",
      title: "manage_buses",
      description: "manage_organize_buses",
      permission: "dashboard.bus.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/buses/:busId",
    name: "bus_show",
    component: () =>
      import(/* webpackChunkName: "BusShow" */ "@/views/admin/buses/show.vue"),
    meta: {
      layout: "default",
      title: "manage_buses",
      description: "manage_organize_buses",
      permission: "dashboard.bus.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/department/:id",
    name: "department_id",
    component: () =>
      import(/* webpackChunkName: "Department" */ "@/views/admin/positions/"),
    meta: {
      layout: "default",
      title: "manage_positions",
      description: "manage_organize_positions",
      permission: "dashboard.position.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/categories",
    name: "categories",
    component: () =>
      import(/* webpackChunkName: "Category" */ "@/views/admin/categories/"),
    meta: {
      layout: "default",
      title: "manage_categories",
      description: "manage_organize_categories",
      permission: "dashboard.category.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/employees",
    name: "employees",
    component: () =>
      import(/* webpackChunkName: "Employees" */ "@/views/admin/employees/"),
    meta: {
      layout: "default",
      title: "manage_employees",
      description: "manage_organize_employees",
      permission: "dashboard.employee.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/employee/create",
    name: "employee_create",
    component: () =>
      import(
        /* webpackChunkName: "employeesCreate" */ "@/views/admin/employees/create.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_employees",
      description: "manage_organize_employees",
      permission: "dashboard.employee.create",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/employee/edit/:id",
    name: "employee_edit",
    component: () =>
      import(
        /* webpackChunkName: "employeeEdit" */ "@/views/admin/employees/edit.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_employees",
      description: "manage_organize_teachers",
      permission: "dashboard.employee.update",
      middleware: [isAuth, isAuthorized],
    },
  },

  {
    path: "/notifications",
    name: "notifications",
    component: () =>
      import(
        /* webpackChunkName: "Notifications" */ "@/views/admin/notifications/"
      ),
    meta: {
      layout: "default",
      title: "manage_notifications",
      description: "manage_organize_notifications",
      permission: "dashboard.notification.list",
      types: ["ADMIN", "EMPLOYEE"],
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/complaints",
    redirect: "/complaints/inbox",
  },
  {
    path: "/complaints/inbox",
    name: "complaints_inbox",
    component: () =>
      import(
        /* webpackChunkName: "Complaints Inbox" */ "@/views/admin/complaints/inbox/index.vue"
      ),
    meta: {
      layout: "default",
      title: "complaints_inbox",
      description: "manage_complaints_inbox",
      permission: "dashboard.complaint.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/complaints/categories",
    name: "complaint_categories",
    component: () =>
      import(
        /* webpackChunkName: "Complaint Categories" */ "@/views/admin/complaints/categories/index.vue"
      ),
    meta: {
      layout: "default",
      title: "complaint_categories",
      description: "manage_complaint_categories",
      permission: "dashboard.complaintCategory.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/frequency-notes",
    name: "frequency_notes",
    component: () =>
      import(
        /* webpackChunkName: "Frequency Notes" */ "@/views/admin/frequencyNotes/index.vue"
      ),
    meta: {
      layout: "default",
      title: "frequency_notes",
      description: "frequency_notes_hint",
      permission: "dashboard.frequencyNote.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: () =>
      import(
        /* webpackChunkName: "Settings" */ "@/views/admin/settings/index.vue"
      ),
    meta: {
      layout: "default",
      title: "settings",
      description: "manage_settings",
      permission: "dashboard.setting.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/billboards",
    name: "billboards",
    component: () =>
      import(
        /* webpackChunkName: "Billboards" */ "@/views/admin/billboards/index.vue"
      ),
    meta: {
      layout: "default",
      title: "billboards",
      description: "manage_billboards",
      permission: "dashboard.billboard.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/sliders",
    name: "sliders",
    component: () =>
      import(/* webpackChunkName: "Sliders" */ "@/views/admin/sliders/"),
    meta: {
      layout: "default",
      title: "manage_sliders",
      description: "manage_organize_sliders",
      permission: "dashboard.slider.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/year/:yearId/general-quizzes",
    name: "general-quizzes",
    component: () =>
      import(
        /* webpackChunkName: "General Quizzes" */ "@/views/admin/years/generalQuizes/index.vue"
      ),
    meta: {
      layout: "default",
      title: "manage_general_quizzes",
      description: "manage_organize_general_quizzes",
      permission: "dashboard.generalQuiz.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/question/:questionId",
    name: "admin_question_show",
    component: () =>
      import(
        /* webpackChunkName: "Question Edit" */ "@/views/admin/grades/subjects/curricula/units/lessons/questions/edit.vue"
      ),
    meta: {
      layout: "default",
      permission: "dashboard.grade.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competitions",
    name: "competitions",
    component: () =>
      import(
        /* webpackChunkName: "Competitions" */ "@/views/admin/competitions/index.vue"
      ),
    meta: {
      layout: "default",
      title: "competitions",
      description: "manage_competitions",
      permission: "dashboard.competition.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competitions/create",
    name: "competitions_create",
    component: () =>
      import(
        /* webpackChunkName: "Competition Create" */ "@/views/admin/competitions/create.vue"
      ),
    meta: {
      layout: "default",
      title: "add_competition",
      description: "manage_competitions",
      permission: "dashboard.competition.create",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competitions/edit/:id",
    name: "competitions_edit",
    component: () =>
      import(
        /* webpackChunkName: "Competition Edit" */ "@/views/admin/competitions/create.vue"
      ),
    meta: {
      layout: "default",
      title: "edit_competition",
      description: "manage_competitions",
      permission: "dashboard.competition.update",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competitions/totals",
    name: "competitions_totals",
    component: () =>
      import(
        /* webpackChunkName: "Competition Totals" */ "@/views/admin/competitions/totals.vue"
      ),
    meta: {
      layout: "default",
      title: "competition_awards",
      description: "manage_competition_awards",
      permission: "dashboard.competition.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competitions/all-winners",
    name: "competitions_all_winners",
    component: () =>
      import(
        /* webpackChunkName: "Competition All Winners" */ "@/views/admin/competitions/allWinners.vue"
      ),
    meta: {
      layout: "default",
      title: "all_competition_winners",
      description: "all_competition_winners_hint",
      permission: "dashboard.competition.allWinners",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competitions/students/:studentId/points",
    name: "competitions_student_points",
    component: () =>
      import(
        /* webpackChunkName: "Competition Student Points" */ "@/views/admin/competitions/studentPoints.vue"
      ),
    meta: {
      layout: "default",
      title: "student_award_history",
      description: "manage_competition_awards",
      permission: "dashboard.competition.studentAwardLogs",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competitions/award-logs",
    name: "competitions_student_award_logs",
    component: () =>
      import(
        /* webpackChunkName: "Competition Student Award Logs" */ "@/views/admin/competitions/studentPoints.vue"
      ),
    meta: {
      layout: "default",
      title: "student_award_history",
      description: "manage_competition_awards",
      permission: "dashboard.competition.studentAwardLogs",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competitions/:id",
    name: "competitions_show",
    component: () =>
      import(
        /* webpackChunkName: "Competition Show" */ "@/views/admin/competitions/show.vue"
      ),
    meta: {
      layout: "default",
      title: "competition",
      description: "manage_competitions",
      permission: "dashboard.competition.show",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competition-repo-questions",
    name: "competition_repo_questions",
    component: () =>
      import(
        /* webpackChunkName: "Competition Repo Questions" */ "@/views/admin/competitions/repo-questions/index.vue"
      ),
    meta: {
      layout: "default",
      title: "competition_repo_questions",
      description: "manage_competition_repo_questions",
      permission: "dashboard.competitionRepoQuestion.list",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competition-repo-questions/create",
    name: "competition_repo_questions_create",
    component: () =>
      import(
        /* webpackChunkName: "Competition Repo Question Create" */ "@/views/admin/competitions/repo-questions/form.vue"
      ),
    meta: {
      layout: "default",
      title: "add_competition_repo_question",
      description: "manage_competition_repo_questions",
      permission: "dashboard.competitionRepoQuestion.create",
      middleware: [isAuth, isAuthorized],
    },
  },
  {
    path: "/competition-repo-questions/edit/:id",
    name: "competition_repo_questions_edit",
    component: () =>
      import(
        /* webpackChunkName: "Competition Repo Question Edit" */ "@/views/admin/competitions/repo-questions/form.vue"
      ),
    meta: {
      layout: "default",
      title: "edit_competition_repo_question",
      description: "manage_competition_repo_questions",
      permission: "dashboard.competitionRepoQuestion.update",
      middleware: [isAuth, isAuthorized],
    },
  },
];
